import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import heroImage from "../assets/portada-kujipy.webp";
import cultureImage from "../assets/casa_frijol.webp";
import liveImage from "../assets/musicos4.webp";
import MusicPlayer from "../components/MusicPlayer/MusicPlayer";
import "./inicio.css";

const Inicio = () => {
  const { t } = useTranslation();
  return <div className="home-page">
    <section className="home-hero" aria-labelledby="home-title">
      <img className="home-hero__image" src={heroImage} alt="Kujipy durante una presentación" />
      <div className="home-hero__shade" />
      <div className="home-hero__content site-container">
        <p className="eyebrow eyebrow--light">{t("home.location")}</p>
        <h1 id="home-title">{t("home.title")}</h1>
        <p className="home-hero__lead">{t("home.subtitle")}</p>
        <div className="button-row">
          <Link className="button button--primary" to="/music">{t("home.ctaMusic")}</Link>
          <Link className="button button--light" to="/hiring">{t("home.booking")}</Link>
        </div>
      </div>
      <a className="home-hero__scroll" href="#historia" aria-label="Bajar al contenido">↓</a>
    </section>

    <main>
      <section id="historia" className="home-intro section-pad site-container">
        <p className="eyebrow">{t("home.traditionLabel")}</p>
        <div className="home-intro__grid">
          <h2>{t("home.storyTitle")}</h2>
          <div><p>{t("home.intro")}</p><Link className="text-link" to="/history">{t("home.storyLink")} <span>→</span></Link></div>
        </div>
      </section>

      <section className="section-pad section-pad--topless site-container"><MusicPlayer /></section>

      <section className="home-game site-container">
        <div className="home-game__art" style={{ backgroundImage: 'url("/game/assets/background.webp")' }}><img src="/game/assets/tipcho.webp" alt={t("home.gameAlt")} loading="lazy" /></div>
        <div className="home-game__copy"><p className="eyebrow eyebrow--light">{t("home.gameLabel")}</p><h2>{t("home.gameTitle")}</h2><p>{t("home.gameText")}</p><a className="button button--game" href="/game/">{t("home.gameCta")} →</a></div>
      </section>

      <section className="home-stories section-pad site-container">
        <article className="story-card story-card--large">
          <img src={cultureImage} alt="El maíz y la vida comunitaria en Tlahuitoltepec" loading="lazy" />
          <div><p className="eyebrow eyebrow--light">{t("home.cultureLabel")}</p><h2>{t("home.cultureTitle")}</h2><Link to="/culture">{t("home.cultureLink")} →</Link></div>
        </article>
        <article className="story-card">
          <img src={liveImage} alt="Músicos de Kujipy tocando instrumentos de viento" loading="lazy" />
          <div><p className="eyebrow eyebrow--light">{t("home.liveLabel")}</p><h2>{t("home.liveTitle")}</h2><Link to="/gallery">{t("home.galleryLink")} →</Link></div>
        </article>
      </section>

      <section className="home-booking section-pad">
        <div className="site-container home-booking__inner"><div><p className="eyebrow">{t("home.bookingLabel")}</p><h2>{t("home.bookingTitle")}</h2></div><div><p>{t("home.bookingText")}</p><div className="button-row"><Link className="button button--primary" to="/hiring">{t("home.contact")}</Link><Link className="button button--outline" to="/epk">{t("home.viewEpk")}</Link></div></div></div>
      </section>
    </main>
  </div>;
};

export default Inicio;
